/**
 * Created by lihanying on 2017/7/14.
 */
import React from 'react'
import './style.css'

const Reminder = props => {
  return (
    <div className="reminder-box">
      <div className="reminder">
        <p className="reminder-info">很抱歉,您没有权限</p>
      </div>
    </div>

  )

}

export default Reminder


// WEBPACK FOOTER //
// ./src/components/Permission/index.js